import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';

import {
  insert,
  update,
  copy,
  softDelete,
  restore,
  hardDelete,
  checkIfValid,
  previewSource,
  listSourceAttributes,
  checkIfExistingWrapper,
  InfoInfrastructure,
  listSchemas
} from './server/source-methods-server';

Meteor.methods({
  'sources.insert'(sourceObject, { generate = false, overwrite = false }, userId = this.userId) {
    return insert(sourceObject, { generate, overwrite }, userId);
  },
  'sources.update'(sourceObject, { generate = false, overwrite = false }) {
    return update(sourceObject, { generate, overwrite });
  },
  'sources.copy'(sourceId) {
    return copy(sourceId, this.userId);
  },
  'sources.softDelete'(sourceId) {
    softDelete(sourceId);
  },
  'sources.restore'(sourceId) {
    restore(sourceId);
  },
  'sources.hardDelete'(sourceId) {
    return hardDelete(sourceId);
  },
  'sources.checkIfValid'(source) {
    return checkIfValid(source);
  },
  'sources.previewSource'(source) {
    return previewSource(source);
  },
  'sources.listSourceAttributes'(source) {
    return listSourceAttributes(source);
  },
  'sources.checkIfExistingWrapper'(source) {
    return checkIfExistingWrapper(source);
  },
  'sources.InfoInfrastructure'(info) {
    return InfoInfrastructure(info);
  },
  'sources.ListSchemas'(info) {
    return listSchemas(info);
  }
});

rateLimit({
  methods: [
    'sources.insert',
    'sources.update',
    'sources.copy',
    'sources.softDelete',
    'sources.restore',
    'sources.hardDelete',
    'sources.checkIfValid',
    'sources.previewSource',
    'sources.listSourceAttributes',
    'sources.checkIfExistingWrapper',
    'sources.InfoInfrastructure',
    'sources.ListSchemas'
  ],
  limit: 5,
  timeRange: 1000
});
